import { Routes } from '@angular/router'
import {
  BreakpointAction,
  ChoiceFunction,
  GoalBreakpointOption,
  QuizDataInput,
} from '@naturalcycles/shared'
import { allQuizSections } from '@src/app/constants/quiz'
import { clearFlowAfterCurrentSection } from '@src/app/core/util/quiz.util'
import { Page } from '@src/app/shared/typings/enum/pages'

const commonTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  flow[allQuizSections.goal] = [
    Page.fertilityGoalInfo,
    Page.typicalUse,
    Page.birthControlMethod,
    Page.birthControlMethodInfo,
  ]
  return flow
}

export const planTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  flow[allQuizSections.goal] = [Page.fertilityGoalInfo, Page.plannedPregnancyTiming]
  return flow
}

export const shortQuizTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  return clearFlowAfterCurrentSection(flow, allQuizSections.intro)
}

export const goalBreakpoint367: Required<
  BreakpointAction<GoalBreakpointOption, Page, QuizDataInput>
> = {
  [GoalBreakpointOption.prevent]: commonTransformFunction,
  [GoalBreakpointOption.preventNowPlanLater]: commonTransformFunction,
  [GoalBreakpointOption.plan]: planTransformFunction,
  [GoalBreakpointOption.undecided]: commonTransformFunction,
  [GoalBreakpointOption.trackPregnancy]: shortQuizTransformFunction,
  [GoalBreakpointOption.trackCycle]: commonTransformFunction,
  [GoalBreakpointOption.postPartum]: shortQuizTransformFunction,
  [GoalBreakpointOption.improveWellbeing]: commonTransformFunction,
  [GoalBreakpointOption.manageSymptoms]: commonTransformFunction,
}

export const ab369Routes: Routes = [
  {
    path: Page.typicalUse,
    loadComponent: () =>
      import('./typical-use/typical-use.component').then(m => m.TypicalUseComponent),
  },
]
